<template>
  <main>
    <div class="cont">
      <nav class="steps">
        <p class="on">
          <i>1</i>
          <span>验证手机号</span>
        </p>
        <p :class="{ on: step > 0 }">
          <i>2</i>
          <span>填写账号信息</span>
        </p>
        <p :class="{ on: step > 1 }">
          <i>3</i>
          <span>注册成功</span>
        </p>
      </nav>
      <ul v-show="step === 0">
        <li>
          <el-input v-model="info.phone" placeholder="建议使用常用的手机号码">
            <el-button slot="append" @click="sendSMS">{{ codeTime === null ? '获取验证码' : codeTime+'s' }}</el-button>
          </el-input>
        </li>
        <li>
          <el-input maxlength="4" v-model="info.code" placeholder="请输入验证码"></el-input>
        </li>
      </ul>
      <ul class="max" v-show="step === 1">
        <li class="need">
          <el-input v-model="submit.name">
            <span slot="prepend">客户名称</span>
          </el-input>
        </li>
        <li class="need">
          <el-input type="password" v-model="submit.password">
            <span slot="prepend">密码</span>
          </el-input>
        </li>
        <li class="need">
          <el-input type="password" v-model="submit.confirmPassword">
            <span slot="prepend">确认密码</span>
          </el-input>
        </li>
        <li :class="{need: registerType === 'enterprise'}">
          <el-input v-model="submit.company_name">
            <span slot="prepend">企业名称</span>
          </el-input>
        </li>
        <li :class="{need: registerType === 'enterprise'}">
          <el-input v-model="submit.ContanctPerson">
            <span slot="prepend">联系人</span>
          </el-input>
        </li>
        <li :class="{need: registerType === 'enterprise'}">
          <el-input v-model="submit.ContanctPhone" maxlength="11">
            <span slot="prepend">联系电话</span>
          </el-input>
        </li>
        <li>
          <el-input v-model="submit.Email">
            <span class="prepend" slot="prepend">电子邮箱</span>
          </el-input>
        </li>
        <li>
          <el-input v-model="submit.Referrer" maxlength="11">
            <span slot="prepend">推荐人手机</span>
          </el-input>
        </li>
        <li class="addr">
          <span>地址</span>
          <el-cascader
            v-model="submit.city"
            :options="chinaCity"
            :props="cityProps"
            clearable
            filterable></el-cascader>
          <el-input placeholder="请输入详细地址" v-model="submit.address"></el-input>
        </li>
        <li class="license">
          <span>营业执照</span>
          <label for="license"><input type="file" id="license" @change="selectedFile" accept="image/*"></label>
        </li>
      </ul>
      <div class="protocol" v-show="step === 1">
        <el-checkbox v-model="submit.is_apply_distributor" label="申请成为分销商"></el-checkbox>
        <p @click="showProtocol = true">分销商协议（请仔细阅读，保存视为同意本协议）</p>
      </div>
      <div class="btn">
        <button class="next" v-show="step === 0" @click="registerUser">下一步</button>
        <button class="ok" v-show="step === 1" @click="saveUserInfo">保存</button>
      </div>
      <div class="options" v-show="step === 0">
        <el-radio v-model="registerType" label="user">普通用户注册</el-radio>
        <el-radio v-model="registerType" label="enterprise">企业用户注册</el-radio>
      </div>
      <div class="success" v-show="step === 2">
        <i class="icon-gou"></i>
        <p>注册成功！去<router-link :to="{ name: 'visa' }">主页</router-link>看看吧！({{timing}}s)</p>
      </div>
    </div>
    <el-dialog
      :title="protocol.title"
      :visible.sync="showProtocol"
      width="800px">
      <div class="nodes" v-html="protocol.content"></div>
    </el-dialog>
  </main>
</template>

<script>
import $user from '@api/user';
import $strategy from '@assets/js/strategy';
export default {
  data () {
    return {
      info: {
        phone: null,
        code: null,
      },
      codeTime: null,
      step: 0, // 注册步骤
      registerType: 'user', // user = 普通用户 | enterprise = 企业
      chinaCity: [], // 城市列表
      submit: {
        name: '', // 客户名称
        password: '', // 密码
        confirmPassword: '', // 确认密码
        city: [], // 选择的城市列表
        address: '', // 详细地址
        company_name: '', // 企业名称
        ContanctPerson: '', // 联系人
        ContanctPhone: '', // 联系电话
        Email: '', // 电子邮箱
        Referrer: '', // 推荐人手机
        AttacUrl: '', // 营业执照
        is_apply_distributor: false // 是否申请成为经销商
      },
      // 城市选择配置
      cityProps: {
        expandTrigger: 'hover',
        label: 'name',
        value: 'name'
      },
      timing: 5,
      protocol: {},
      showProtocol: false
    }
  },
  async created () {
    this.chinaCity = window.china_citys;
    const protocol = await $user.getDistributorDesc();
    this.protocol = protocol;
  },
  methods: {
    // 注册用户
    registerUser () {
      const { phone, code } = this.info;
      if ($strategy.check(phone, 'isMobile') === false) {
        this.$message.warning('手机格式有误!');
        return;
      }
      if ( !code || code.length !== 4 ) {
        this.$message.warning('验证码有误!');
        return;
      }

      const { registerType } = this;
      $user.register({ phone, code, is_apply_distributor: registerType === 'enterprise' ? 1 : 0 }).then(res => {
        this.updateUserInfo(res);
        this.step = 1;
      })
    },
    // 发送短信
    sendSMS () {
      const { phone } = this.info;
      if ( this.codeTime !== null ) { return; }
      if ( $strategy.check(phone, 'isMobile') === false ) {  
        this.$message.warning('手机号码有误！');
        return;
      }
      this.startCountdown('codeTime');
      $user.sendSMS(phone);
    },
    // 保存用户信息
    saveUserInfo () {
      if ( this.checkSaveState() === false ) { return; }
      const data = this.getRequestData();
      console.log('用户信息'+JSON.stringify(data))
      console.log(data)
      // return
      $user.updateInfo(data).then(res => {

        this.step = 2;
        this.countdown();
      })
      console.log(data)

    },
    getRequestData () {
      const { name, password, city: citys, address, company_name, ContanctPerson, ContanctPhone, Email, Referrer, AttacUrl, is_apply_distributor } = this.submit;
      const [ province, city, district ] = citys;
      let data = {
        name, password, address, company_name, ContanctPerson, ContanctPhone, Email, Referrer,
        province, city, district,
        is_apply_distributor: is_apply_distributor ? 1 : 0
      };
      !!AttacUrl && (data.AttacUrl = AttacUrl);
      let formData = new FormData();
      Object.keys(data).map(key => {
        formData.append(key, data[key]);
      });
      return formData;
    },
    // 保存信息检测
    checkSaveState () {
      const { name, password, confirmPassword } = this.submit;
      // 通用检查
      if ( $strategy.check(name, 'isEmpty') ) {
        this.emptyHint('客户名称');
        return false;
      }
      if ( $strategy.check(password, 'isEmpty') ) {
        this.emptyHint('密码');
        return false;
      }
      if ( password !== confirmPassword ) {
        this.$message.warning('密码不一致，请检查！');
        return false;
      }
      if ( password.length < 6 ) {
        this.$message.warning('密码最少6位数！');
        return false;
      }
      // 企业客户检查
      if ( this.registerType === 'enterprise' ) {
        const { company_name, ContanctPerson, ContanctPhone } = this.submit;
        if ( $strategy.check(company_name, 'isEmpty') ) {
          this.emptyHint('企业名称');
          return false;
        }
        if ( $strategy.check(ContanctPerson, 'isEmpty') ) {
          this.emptyHint('联系人');
          return false;
        }
        if ( $strategy.check(ContanctPhone, 'isMobile') === false ) {
          this.$message.warning('联系电话格式有误！');
          return false;
        }
      }
      return true;
    },
    emptyHint (desc) {
      this.$message.warning(`${desc}不能为空！`);
    },
    selectedFile (e) {
      const file = e.currentTarget.files[0];
      this.submit = { ...this.submit, AttacUrl: file };
    },
    countdown () {
      let timing = setInterval(() => {
        if (this.timing === 1) {
          clearInterval(timing);
          this.$router.push({ name: 'visa' });
        } else {
          this.timing -= 1;
        }
      }, 1000);
    }
  }
}
</script>

<style scoped src="./register.css"></style>